import { TimelineGrouping, TimelineItem } from './index';

export const decadeFromYear = (year: number) => year - (year % 10);

export const groupByDecade = (items: TimelineItem[]): TimelineGrouping[] => {
  const sorted = [...items].sort((a, b) => a.year - b.year);
  const groupings = sorted.reduce((acc, item) => {
    const itemDecade = decadeFromYear(item.year);
    if (!acc[itemDecade]) {
      acc[itemDecade] = {
        label: `${itemDecade}s`,
        items: [],
      };
    }
    acc[itemDecade].items.push(item);
    return acc;
  }, {} as Record<number, TimelineGrouping>);
  return Object.values(groupings);
};
